import { PayCustomerData as CustomerData } from '@core/models';
import { createReducer, on } from '@ngrx/store';
import { 
  PAY_UPDATE_LOADING, 
  PROCESS_PAYMENT, 
  PROCESS_PAYMENT_SUCCESS, 
  PROCESS_PAYMENT_FAILURE, 
  CLEAR_CUSTOMER_DATA, 
  CLEAR_PAYMENT_DATA, 
  CREATE_CUSTOMER_LOGGED,
  CREATE_CUSTOMER_LOGGED_SUCCESS, 
  CREATE_CUSTOMER_LOGGED_FAILURE
} from '@store/actions';
import { IResponseBadRequest, IResponseObjectSuccess } from '@core/interfaces';
import { PaymentResponseData } from '@core/models';

export interface PaymentState {
  error: IResponseBadRequest | null;
  response: IResponseObjectSuccess<PaymentResponseData> | null;
}


export interface PayState {
  loading: boolean;
	error: IResponseBadRequest | null;
  customerData: CustomerData | null;
  customerLoading: boolean;
  customerError: IResponseBadRequest | null;
  payment: PaymentState;
}


export const initialState: PayState = {
  loading: false,
  error: null,
  customerData: null,
  customerLoading: false,
  customerError: null,
  payment: {
    error: null,
    response: null
  }
};

export const payReducer = createReducer(
  initialState,
  on(PAY_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  
  // Payment actions
  on(PROCESS_PAYMENT, (state) => ({
    ...state,
    payment: {
      ...state.payment,
      error: null
    }
  })),
  on(PROCESS_PAYMENT_SUCCESS, (state, { response }) => ({
    ...state,
    payment: {
      ...state.payment,
      response,
    }
  })),
  on(PROCESS_PAYMENT_FAILURE, (state, { error }) => ({
    ...state,
    payment: {
      ...state.payment,
      error,
    }
  })),

  // Clear actions
  on(CLEAR_CUSTOMER_DATA, (state) => ({
    ...state,
    customerData: null
  })),
  on(CLEAR_PAYMENT_DATA, (state) => ({
    ...state,
    payment: {
      error: null,
      response: null
    }
  })),
  on(CREATE_CUSTOMER_LOGGED, (state) => ({
    ...state,
    customerLoading: true,
    customerError: null
})),
on(CREATE_CUSTOMER_LOGGED_SUCCESS, (state, { customer }) => {
  return {
    ...state,
    customerData: {
      idCustomer: customer.idCustomer,
      clienteId: customer.clienteId,
      customerMerchId: customer.customerMerchId,
      fechaCreacion: customer.fechaCreacion,
      fechaActualizacion: customer.fechaActualizacion,
      cardAccount: {
        token: customer.cardAccount?.token || '', 
        hasContract: false 
      }
    },
    customerLoading: false
  };
}),
on(CREATE_CUSTOMER_LOGGED_FAILURE, (state, { error }) => ({
    ...state,
    customerError: error,
    customerLoading: false
})),
);
